import { createSlice } from "@reduxjs/toolkit";

function setInitialDashboardConsorcioFiltro() {
  const initialFilter = {
    filter: {
      mesReferencia: new Date(),
      idUC: null,
      cpfCnpj: "",
      nomeTitular: "",
      endereco: "",
    },
    sortOrder: "asc",
    sortField: "VINCode",
    pageNumber: 1,
    pageSize: 30
  }

  localStorage.setItem("filtro.DashboardConsorcio", JSON.stringify(initialFilter));

  return initialFilter;
};

const initialDashboardConsorcioState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  lastError: null,
  entities: [],
  bigNumbers: null,
  bigNumbersUltimoMes: null,
  grafico: null,
  historicoEconomia: [],
  consorcios: [],
  // dashboardConsorcioFiltro: localStorage.getItem("filtro.DashboardConsorcio") !== null ? JSON.parse(localStorage.getItem("filtro.DashboardConsorcio")) : setInitialDashboardConsorcioFiltro(),
  dashboardConsorcioFiltro: setInitialDashboardConsorcioFiltro() ,
  notificacoesLead: [],

};

export const callTypes = {
  list: "list",
  action: "action"
};

export const dashboardConsorcioSlice = createSlice({
  name: "dashboardConsorcio",
  initialState: initialDashboardConsorcioState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    fetchBigNumbers: (state, action) => {
      state.actionsLoading = false;
      state.bigNumbers = action.payload.bigNumbers;
      state.error = null;
    },
    fetchBigNumbersUltimoMes: (state, action) => {
      state.actionsLoading = false;
      state.bigNumbersUltimoMes = action.payload.bigNumbersUltimoMes;
      state.error = null;
    },
    fetchGraficoCompararEconomia: (state, action) => {
      state.actionsLoading = false;
      state.grafico = action.payload.grafico;
      state.error = null;
    },
    fetchHistoricoEconomia: (state, action) => {
      state.actionsLoading = false;
      state.historicoEconomia = action.payload.historicoEconomia;
      state.error = null;
    },
    fetchConsorcios: (state, action) => {
      state.actionsLoading = false;
      state.consorcios = action.payload.consorcios;
      state.error = null;
    },
    fetchHistoricoFaturas: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    fetchNotificacoesLead: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.notificacoesLead = entities.resultado;
    },
    dashboardConsorcioFiltro: (state, action) => {
      // state.dashboardConsorcioFiltro = JSON.parse(localStorage.getItem("filtro.DashboardConsorcio"));
      state.dashboardConsorcioFiltro =action.payload.dashboardConsorcioFiltro ;
    },
  }
});
